/**
 * Take a string and if it's over the maximum allowed, cut it short and add an ellipsis. So
 * Long long long text becomes Long Lo...
 * Don't add the elipsis if the text is the right length
 *
 * While we are here, lets add some capitalisation and turn
 * 'everything in lowercase' to 'Everything in lowercase'
 *
 * @param {string} excerpt
 * @param {int} maxLength
 */

const cutOffExcerpt = function(excerpt, maxLength = 200) {
  let newExcerpt = excerpt

  // cut off and add ellipsis
  if (newExcerpt.length > maxLength) {
    newExcerpt = newExcerpt.substr(0, maxLength).trim() + "..."
  }

  // Make first character a capital
  newExcerpt = newExcerpt.replace(/^\w/, c => c.toUpperCase())

  return newExcerpt
}

export default cutOffExcerpt
